<template>
  <div>
    <div>{{ title }}</div>
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_0 = val)"
      @onTypeChange="val => (type_0 = val)"
      :labelTitle="sortPeriods[0].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_1 = val)"
      @onTypeChange="val => (type_1 = val)"
      :labelTitle="sortPeriods[1].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_2 = val)"
      @onTypeChange="val => (type_2 = val)"
      :labelTitle="sortPeriods[2].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_3 = val)"
      @onTypeChange="val => (type_3 = val)"
      :labelTitle="sortPeriods[3].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_4 = val)"
      @onTypeChange="val => (type_4 = val)"
      :labelTitle="sortPeriods[4].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_5 = val)"
      @onTypeChange="val => (type_5 = val)"
      :labelTitle="sortPeriods[5].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_6 = val)"
      @onTypeChange="val => (type_6 = val)"
      :labelTitle="sortPeriods[6].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_7 = val)"
      @onTypeChange="val => (type_7 = val)"
      :labelTitle="sortPeriods[7].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_8 = val)"
      @onTypeChange="val => (type_8 = val)"
      :labelTitle="sortPeriods[8].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_9 = val)"
      @onTypeChange="val => (type_9 = val)"
      :labelTitle="sortPeriods[9].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_10 = val)"
      @onTypeChange="val => (type_10 = val)"
      :labelTitle="sortPeriods[10].title"
    />
    <headFeeDetailPriceEach
      @onPriceChange="val => (price_11 = val)"
      @onTypeChange="val => (type_11 = val)"
      :labelTitle="sortPeriods[11].title"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import headFeeDetailPriceEach from './headFeeDetailPriceEach.vue'
import { sortPeriod } from './helper/period'

export default {
  components: { headFeeDetailPriceEach },
  data() {
    return {
      price_0: '0',
      price_1: '0',
      price_2: '0',
      price_3: '0',
      price_4: '0',
      price_5: '0',
      price_6: '0',
      price_7: '0',
      price_8: '0',
      price_9: '0',
      price_10: '0',
      price_11: '0',
      type_0: 'fixed',
      type_1: 'fixed',
      type_2: 'fixed',
      type_3: 'fixed',
      type_4: 'fixed',
      type_5: 'fixed',
      type_6: 'fixed',
      type_7: 'fixed',
      type_8: 'fixed',
      type_9: 'fixed',
      type_10: 'fixed',
      type_11: 'fixed'
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    ...mapGetters({
      periods: 'tuitionFeePeriod/periods'
    }),
    sortPeriods() {
      return sortPeriod(this.periods)
    },
    title() {
      let titleMiddle = ''
      if (this.router === 'normal') {
        if (!this.isSubFee) titleMiddle = 'mức đóng'
        else titleMiddle = 'mức truy thu'
      } else if (this.isSubFee) titleMiddle = 'mức hoàn trả'
      else titleMiddle = 'mức giảm trừ'
      return `Nhập ${titleMiddle} từng tháng`
    },
  },
  methods: {
    getData() {
      const result = {}
      this.sortPeriods.forEach((item, index) => {
        result[item.id] = {
          value: String(this[`price_${index}`])
            .split(/\s*,\s*/)
            .join(''),
          type: String(this[`type_${index}`])
        }
      })
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
.input-wrapper {
  width: 100%;
}
.input-wrapper--with-type {
  width: 60%;
}
.type-wrapper {
  width: 40%;
}
</style>
